import { MdTimeline as GraphIcon } from 'react-icons/md';

export default GraphIcon;
